import Icon from '../components/Icon.vue'

Icon.register({"hammer":{"width":576,"height":512,"paths":[{"d":"M571.3 193.9L548.7 171.3C542.4 165.1 532.3 165.1 526 171.3L514.7 182.6 485.8 153.7C491.5 132.4 486.2 108.8 469.5 92.1L424.2 46.9C361.8-15.6 260.5-15.6 198 46.9L288.5 92.1V110.9C288.5 127.8 295.2 144.1 307.2 156.1L356.4 205.3C373.1 222 396.7 227.2 418 221.6L446.9 250.5 435.6 261.8C429.3 268.1 429.3 278.2 435.6 284.4L458.2 307.1C464.4 313.3 474.6 313.3 480.8 307.1L571.3 216.6C577.6 210.3 577.6 200.2 571.3 193.9zM284.6 178.7C280.9 175 277.8 170.9 274.7 166.8L19.6 405C-5.9 428.8-6.6 469.1 18.1 493.9S83.2 517.9 107 492.4L345.2 237.3C341.2 234.4 337.3 231.4 333.7 227.9L284.6 178.7z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/hammer.js
// module id = null
// module chunks = 